import { createFileRoute } from '@tanstack/react-router'
import { OpsInboxTabContent } from '@/pages/OpsInbox'

export const Route = createFileRoute('/_authenticated/ops-inbox/ai-action-reviews')({
  component: () => <OpsInboxTabContent filterType="ai_action_review" />,
})
